import React, { useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { HomePage } from '../../pages/home'
import { FirestoreContext } from '../../providers/firestore-provider'
import { PrivateRoute } from '../../routes'
import UsernameForm from '../username-form'

import SignIn from './SignIn'

const Authentication = () => {
  const { currentUser, username } = useContext(FirestoreContext)

  const history = useHistory()

  useEffect(() => {
    if (currentUser && username) {
      history.push('/')
    }
  }, [currentUser, history, username])

  return (
    <div>
      {currentUser ? (
        !username ? (
          <UsernameForm />
        ) : (
          <PrivateRoute exact path="/" component={HomePage} />
        )
      ) : (
        <SignIn />
      )}
    </div>
  )
}

export default Authentication
